import { css } from 'lit';

export const styles = css`
	:host {
		--_sds-card-background-color: var(--sds-card-background-color, var(--sds-color-surface-tinted, var(--sds-color-main-surface-tinted)));
		--_sds-card-border-radius: var(--sds-card-border-radius, var(--sds-radius-md));
		--_sds-card-padding: var(--sds-card-padding, var(--sds-spacing-xs));
		--_sds-card-gap: var(--sds-card-gap, var(--sds-spacing-3xs));
		--_sds-card-font-family: var(--sds-card-font-family, var(--sds-typography-font-family));
		--_sds-card-focus-color: var(--sds-card-focus-color, var(--sds-color-states-focus-outer));
		--_sds-card-focus-inner-color: var(--sds-card-focus-inner-color, var(--sds-color-states-focus-inner));
		--_sds-card-focus-spacing: var(--sds-card-focus-spacing, var(--sds-color-states-focus-spacing));
		--_sds-card-icon-color: var(--sds-card-icon-color, var(--sds-color-action-default, var(--sds-color-main-action-default)));

		--_sds-card-heading-color: var(--sds-card-heading-color, var(--sds-color-text-default, var(--sds-color-main-text-default)));
		--_sds-card-heading-font-size: var(--sds-card-heading-font-size, var(--sds-typography-heading-md-mobile-font-size));
		--_sds-card-heading-font-weight: var(--sds-card-heading-font-weight, var(--sds-typography-heading-md-mobile-font-weight));
		--_sds-card-heading-line-height: var(--sds-card-heading-line-height, var(--sds-typography-heading-md-mobile-line-height));

		--_sds-card-text-color: var(--sds-card-text-color, var(--sds-color-text-default, var(--sds-color-neutral-text-default)));
		--_sds-card-text-font-size: var(--sds-card-text-font-size, var(--sds-typography-body-md-mobile-font-size));
		--_sds-card-text-font-weight: var(--sds-card-text-font-weight, var(--sds-typography-body-md-mobile-font-weight));
		--_sds-card-text-line-height: var(--sds-card-text-line-height, var(--sds-typography-body-md-mobile-line-height));

		display: flex;
	}

	.sds-card {
		display: flex;
		flex: 1;
	}

	.sds-card__content {
		background-color: var(--_sds-card-background-color);
		border-radius: var(--_sds-card-border-radius);
		font-family: var(--_sds-card-font-family);
		padding: var(--_sds-card-padding);
		gap: var(--_sds-card-gap);
		display: flex;
		flex-direction: row;
		text-decoration: none;
		align-items: center;
		flex: 1;

		&:hover {
			--_sds-card-background-color: var(--sds-card-background-color, var(--sds-color-surface-hover, var(--sds-color-main-surface-hover)));
		}

		&:active {
			--_sds-card-background-color: var(--sds-card-background-color, var(--sds-color-surface-active, var(--sds-color-main-surface-active)));
		}

		&:focus-visible {
			box-shadow: 0 0 0 var(--sds-color-states-focus-spacing) var(--_sds-card-focus-inner-color);
			outline: var(--_sds-card-focus-spacing) solid var(--_sds-card-focus-color);
			outline-offset: var(--_sds-card-focus-spacing);
		}
	}

	.sds-card__icon {
		color: var(--_sds-card-icon-color);
		margin-inline-start: auto;
	}

	::slotted(p) {
		color: var(--_sds-card-text-color) !important;
		display: none !important;
		font-size: var(--_sds-card-text-font-size) !important;
		line-height: var(--_sds-card-text-line-height) !important;
		margin: 0 !important;
		max-width: var(--sds-typography-max-line-width) !important;
		text-wrap: pretty !important;
	}

	::slotted(h2),
	::slotted(h3),
	::slotted(h4),
	::slotted(h5),
	::slotted(h6) {
		color: var(--_sds-card-heading-color) !important;
		font-size: var(--_sds-card-heading-font-size) !important;
		font-weight: var(--_sds-card-heading-font-weight) !important;
		line-height: var(--_sds-card-heading-line-height) !important;
		margin: 0 !important;
		max-width: var(--sds-typography-max-line-width) !important;
		text-wrap: pretty !important;
	}

	@media (min-width: 640px) {
		:host {
			--_sds-card-heading-font-size: var(--sds-card-heading-font-size, var(--sds-typography-heading-md-tablet-font-size));
			--_sds-card-heading-font-weight: var(--sds-card-heading-font-weight, var(--sds-typography-heading-md-tablet-font-weight));
			--_sds-card-heading-line-height: var(--sds-card-heading-line-height, var(--sds-typography-heading-md-tablet-line-height));
			--_sds-card-text-font-size: var(--sds-card-text-font-size, var(--sds-typography-body-md-tablet-font-size));
			--_sds-card-text-font-weight: var(--sds-card-text-font-weight, var(--sds-typography-body-md-tablet-font-weight));
			--_sds-card-text-line-height: var(--sds-card-text-line-height, var(--sds-typography-body-md-tablet-line-height));
			--_sds-card-padding: var(--sds-card-padding, var(--sds-spacing-sm));
		}

		.sds-card__content {
			flex-direction: column;
			align-items: start;
		}

		.sds-card__icon {
			display: none;
		}

		::slotted(p) {
			display: block !important;
		}
	}

	@media (min-width: 1024px) {
		:host {
			--_sds-card-heading-font-size: var(--sds-card-heading-font-size, var(--sds-typography-heading-md-desktop-font-size));
			--_sds-card-heading-font-weight: var(--sds-card-heading-font-weight, var(--sds-typography-heading-md-desktop-font-weight));
			--_sds-card-heading-line-height: var(--sds-card-heading-line-height, var(--sds-typography-heading-md-desktop-line-height));
			--_sds-card-text-font-size: var(--sds-card-text-font-size, var(--sds-typography-body-md-desktop-font-size));
			--_sds-card-text-font-weight: var(--sds-card-text-font-weight, var(--sds-typography-body-md-desktop-font-weight));
			--_sds-card-text-line-height: var(--sds-card-text-line-height, var(--sds-typography-body-md-desktop-line-height));
		}
	}
`;
